import { GET, POST, PUT } from '../request'

export const getCaja = fecha => GET('/api/agora/contabilidad/caja', { fecha })

export const getCajaList = mes =>
  GET('/api/agora/contabilidad/caja/list', { mes })

export const createCaja = ({ balance_inicial, observaciones }) =>
  POST('/api/agora/contabilidad/caja', { balance_inicial, observaciones })

export const cerrarCaja = ({ balance, fecha, observaciones }) =>
  PUT('/api/agora/contabilidad/caja', { balance, fecha, observaciones })
